// Indikator Keaktifan Akun (Super Admin & Admin UFP) -- fungsi murni tampilan. Status & selisih hari dihitung
// SERVER (GET /admin/keaktifan, hari kalender WIB); di sini hanya label, teks relatif, dan persen.

// Warna selalu disertai teks (bukan warna saja) demi aksesibilitas.
export const STATUS_KEAKTIFAN = {
    hijau: { label: "Aktif", kelas: "bg-emerald-500" },
    kuning: { label: "Jarang", kelas: "bg-amber-500" },
    merah: { label: "Tidak aktif", kelas: "bg-rose-500" },
    abu: { label: "Belum pernah login", kelas: "bg-slate-400" },
};

export function teksRelatifHari(hari) {
    if (hari == null) return "Belum pernah";
    if (hari <= 0) return "Hari ini";
    if (hari === 1) return "Kemarin";
    return `${hari} hari lalu`;
}

// Keterangan ambang dari server (ambang.hijau_maks_hari / kuning_maks_hari).
export function keteranganAmbang(ambang) {
    if (!ambang) return {};
    const h = ambang.hijau_maks_hari;
    const k = ambang.kuning_maks_hari;
    return { hijau: `≤ ${h} hari`, kuning: `${h + 1}–${k} hari`, merah: `> ${k} hari`, abu: "belum ada catatan login" };
}

export const teksPersen = (p) => (p == null ? "-" : `${p}%`);

// Tab halaman keaktifan (/users & /keaktifan), disimpan di parameter URL ?tab=. Nilai tak dikenal/kosong -> tab
// bawaan halaman. Tidak ada yang disimpan di server.
export const TAB_KEAKTIFAN = { akun: "akun", prodi: "prodi" };
export const LABEL_TAB_KEAKTIFAN = { akun: "Status Akun", prodi: "Ringkasan per Program Studi" };

export function tabKeaktifanDariUrl(nilai, bawaan) {
    return Object.values(TAB_KEAKTIFAN).includes(nilai) ? nilai : bawaan;
}

// Pilihan bulan Ringkasan per Program Studi: daftar "TTTT-BB" dari server (pilihan_bulan, rentang sama dgn aturan
// server); di sini hanya label. Nilai tak dikenal ditampilkan apa adanya.
export const NAMA_BULAN = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September",
    "Oktober", "November", "Desember"];

export const bulanIso = (bulan, tahun) => `${tahun}-${String(bulan).padStart(2, "0")}`;

export function labelBulanIso(iso) {
    const m = /^(\d{4})-(\d{2})$/.exec(iso || "");
    const nama = m && NAMA_BULAN[Number(m[2]) - 1];
    return nama ? `${nama} ${m[1]}` : String(iso ?? "");
}

// Pemilih Tahun + Bulan: keduanya diturunkan dari SATU daftar `pilihan_bulan` server ("TTTT-BB", terbaru dulu),
// jadi tidak ada tahun/bulan yang ditulis tetap di sini dan rentangnya otomatis ikut berganti tahun.
const pecahIso = (iso) => {
    const m = /^(\d{4})-(\d{2})$/.exec(iso || "");
    return m ? { tahun: Number(m[1]), bulan: Number(m[2]) } : null;
};

// Tahun yang punya minimal satu bulan sah, terbaru dulu.
export function daftarTahun(pilihan) {
    const tahun = (pilihan || []).map(pecahIso).filter(Boolean).map((p) => p.tahun);
    return [...new Set(tahun)].sort((a, b) => b - a);
}

// Bulan (1-12) yang sah di tahun itu, urut Januari dulu.
export function daftarBulanDiTahun(pilihan, tahun) {
    return (pilihan || []).map(pecahIso).filter((p) => p && p.tahun === Number(tahun)).map((p) => p.bulan).sort((a, b) => a - b);
}

// Ganti tahun: bulan terpilih dipertahankan bila sah di tahun baru, kalau tidak diganti bulan sah terdekat
// (selisih sama -> yang lebih awal). Mengembalikan "TTTT-BB", atau null bila tahun itu tak punya bulan sah.
export function isoSetelahGantiTahun(pilihan, tahunBaru, bulanTerpilih) {
    const sah = daftarBulanDiTahun(pilihan, tahunBaru);
    if (!sah.length) return null;
    const terdekat = sah.reduce((a, b) => (Math.abs(b - bulanTerpilih) < Math.abs(a - bulanTerpilih) ? b : a));
    return bulanIso(terdekat, tahunBaru);
}

// Pemilih jenjang Ringkasan per Program Studi. Nilai = parameter ?jenjang= server (huruf kecil); "semua" = tanpa parameter.
export const PILIHAN_JENJANG = [
    { nilai: "semua", label: "Semua" }, { nilai: "sp1", label: "Sp1" }, { nilai: "sp2", label: "Sp2" }, { nilai: "koas", label: "Koas" },
];

// Parameter permintaan ke server dari pilihan bulan ("TTTT-BB" atau null) & jenjang; kunci kosong tidak dikirim.
export function paramRingkasan(bulan, jenjang) {
    const params = {};
    if (bulan) params.bulan = bulan;
    if (jenjang && jenjang !== "semua") params.jenjang = jenjang;
    return params;
}

// Filter Jenjang di sisi layar: respons "Semua" dari server sudah memuat semua bagian (Sp1, Sp2, Koas, dst.) dgn totalnya
// masing-masing, jadi memilih satu jenjang cukup menyaring bagian itu -- hasilnya sama dgn respons server ?jenjang=.
export function bagianTampil(bagian, jenjang) {
    if (!jenjang || jenjang === "semua") return bagian || [];
    return (bagian || []).filter((b) => String(b.jenjang || "").toLowerCase() === jenjang);
}
